import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Big } from 'foundations-components/transitional/components/Big';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { Select } from 'foundations-components/transitional/components/Select';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { View } from 'foundations-components/transitional/components/View';
import { UrlPartType } from '../../types';
import { HelpContent } from '../HelpContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function UrlStepItem({
  item,
  label,
  params,
  onChange
}) {
  var _item$tooltip2;
  const name = item.name;
  const value = params[item.name];
  const urlStep = item;
  const renderedParts = urlStep.parts.map((part, index) => {
    var _item$tooltip;
    const key = `${part.type}${index.toString()}`;
    const partValue = value ? value[index] : undefined;
    let child;
    let error = false;
    const validationMessages = [];
    switch (part.type) {
      case UrlPartType.Static:
        child = /*#__PURE__*/_jsx(Big, {
          children: part.value
        });
        break;
      case UrlPartType.Select:
        child = /*#__PURE__*/_jsx(Select, {
          options: part.options.map(option => ({
            text: option,
            value: option
          })),
          value: partValue,
          onChange: event => {
            const nextValue = event.target.value;
            const nextValues = value && Array.isArray(value) ? value.slice() : new Array(urlStep.parts.length).fill('');
            nextValues[index] = nextValue;
            onChange(name, nextValues);
          },
          menuWidth: "auto"
        });
        break;
      case UrlPartType.Domain:
      case UrlPartType.Path:
        {
          if (part.validation) {
            const isInvalid = partValue && !new RegExp(part.validation.regex).test(partValue);
            if (isInvalid) {
              error = true;
              validationMessages.push( /*#__PURE__*/_jsx(Text, {
                as: "small",
                use: "error",
                children: part.validation.message
              }, `${part.type}${index.toString()}`));
            }
          }
          child = /*#__PURE__*/_jsx(TextInput, {
            placeholder: part.placeholder,
            value: partValue,
            onChange: event => {
              const nextValue = event.target.value;
              const nextValues = value && Array.isArray(value) ? value.slice() : new Array(urlStep.parts.length).fill('');
              nextValues[index] = nextValue;
              onChange(name, nextValues);
            }
          });
          break;
        }
      default:
        child = null;
    }
    if (index > 0 && child) {
      child = /*#__PURE__*/_jsxs(Flex, {
        alignItems: "baseline",
        gap: "100",
        children: [/*#__PURE__*/_jsx(View, {
          children: part.type === 'Path' ? '/' : '.'
        }), /*#__PURE__*/_jsx(View, {
          children: child
        })]
      });
    }
    return /*#__PURE__*/_jsx(FormControl, {
      tooltip: (_item$tooltip = item.tooltip) === null || _item$tooltip === void 0 ? void 0 : _item$tooltip.text,
      error: error,
      validationMessage: validationMessages,
      "aria-label": part.type,
      children: child
    }, key);
  });
  return urlStep.parts.length === 1 ? /*#__PURE__*/_jsx(FormControl, {
    label: label,
    required: urlStep.required,
    tooltip: (_item$tooltip2 = item.tooltip) === null || _item$tooltip2 === void 0 ? void 0 : _item$tooltip2.text,
    help: /*#__PURE__*/_jsx(HelpContent, {
      helpData: item.help
    }),
    children: renderedParts[0]
  }) : /*#__PURE__*/_jsx(InputGroup, {
    label: label,
    required: urlStep.required,
    use: "none",
    help: /*#__PURE__*/_jsx(HelpContent, {
      helpData: item.help
    }),
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      gap: "100",
      children: renderedParts
    })
  });
}